import { render, staticRenderFns } from "./FirstChoice.vue?vue&type=template&id=a2663160"
import script from "./FirstChoice.vue?vue&type=script&lang=js"
export * from "./FirstChoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports